import { render, staticRenderFns } from "./EraserMenu.vue?vue&type=template&id=26b08958&scoped=true"
import script from "./EraserMenu.vue?vue&type=script&lang=js"
export * from "./EraserMenu.vue?vue&type=script&lang=js"
import style0 from "./EraserMenu.vue?vue&type=style&index=0&id=26b08958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@2.8.8_underscore@1.13.7_vue-t_t2nkcq7z6p7kqveyao2fqanapi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b08958",
  null
  
)

export default component.exports